import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './css/dashboard.css'
import './css/formularios-ui.css'
import './index.css'
import Core from './components/core'
import Config from './components/config_site.json'
import applySiteBranding from './utils/siteBranding'

applySiteBranding(Config)

ReactDOM.render(<Core/>, document.getElementById('root'));

